import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const MemberRecognition = ({ recognitions }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Award" size={20} className="text-accent" />
        <h3 className="font-heading font-semibold text-foreground">Member Recognition</h3>
      </div>
      <div className="space-y-4">
        {recognitions?.map((recognition, index) => (
          <div key={index} className="flex items-center space-x-3 p-3 bg-accent/5 rounded-lg">
            <Image
              src={recognition?.member?.avatar}
              alt={recognition?.member?.name}
              className="w-10 h-10 rounded-full object-cover"
            />
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-1">
                <span className="font-medium text-foreground text-sm">
                  {recognition?.member?.name}
                </span>
                <div className={`px-2 py-1 rounded-full text-xs font-caption ${recognition?.badge?.color}`}>
                  {recognition?.badge?.name}
                </div>
              </div>
              
              <p className="text-xs text-muted-foreground">
                {recognition?.achievement}
              </p>
            </div>
            
            <div className="flex items-center space-x-1 text-accent">
              <Icon name={recognition?.icon} size={16} />
              <span className="text-xs font-medium">{recognition?.points}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="text-center">
          <p className="text-sm text-muted-foreground mb-2">
            Next Recognition Event
          </p>
          <div className="flex items-center justify-center space-x-2 text-accent">
            <Icon name="Calendar" size={16} />
            <span className="font-medium text-sm">December 15, 2024</span>
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            Semi-annual Wellness Awards
          </p>
        </div>
      </div>
    </div>
  );
};

export default MemberRecognition;